import { EpModal } from '@/components/EpModal';
import { useTranslation as t } from '@/hooks/useTranslation';
import './styles.scss';

import { useHospitalStore, useTranslationStore } from '../../stores';

import Parse from 'html-react-parser';
import {
  IGetStampsResponse,
  stampsService,
} from '../../services/stampsService';
import { hideModal } from '../../components/EpModal';
import { userService } from '../../services/userService';
import { tenantServices } from '../../services/tenantServices';
import { getDefaultAccess } from '../../utils/defaultAccess';
import { useEffect } from 'react';
import { IButtonType, IEpModalButtonList } from '../../interfaces';

export default function PatientSafetySealModal({
  stamp,
  viewStamp,
}: {
  stamp: IGetStampsResponse;
  viewStamp?: any;
}) {
  const { translations } = useTranslationStore((state) => state);
  const { addCountryCode } = useHospitalStore((state) => state);
  const hospitalInfo = getDefaultAccess();

  const { getHospitalInfo } = userService;
  const { data: contactInfo } = getHospitalInfo(
    hospitalInfo ? hospitalInfo.hospitalId : '',
    !!hospitalInfo?.hospitalId,
  );

  const { GetLoggedCountryCode, GetUnLoggedCountryCode } = tenantServices;

  const { data: loggedCountryCode } = GetLoggedCountryCode({
    hospitalSourceId: hospitalInfo?.hospitalId as string,
  });

  const { data: unLoggedCountryCode } = GetUnLoggedCountryCode({
    hospitalSourceId: hospitalInfo?.hospitalId as string,
  });

  const isMexico =
    loggedCountryCode?.countryCode === 'MX' ||
    unLoggedCountryCode?.countryCode === 'MX' ||
    (loggedCountryCode as unknown as string) === 'MX' ||
    (unLoggedCountryCode as unknown as string) === 'MX';

  const { PostViewStamp } = stampsService;

  const { mutate: fetchViewStamp } = PostViewStamp({
    hospitalId: hospitalInfo?.hospitalId || '',
    categoryId: process.env.NEXT_PUBLIC_PATIENTY_SAFETY_STAMP_CATEGORY_ID || '',
    year: stamp?.year || '',
  });

  useEffect(() => {
    addCountryCode(
      (loggedCountryCode?.countryCode as string) ||
        (unLoggedCountryCode?.countryCode as string),
    );
  }, [loggedCountryCode, unLoggedCountryCode]);
  return (
    <EpModal
      key={`modal--sp-seal-1`}
      modalId={`modal--sp-seal-id`}
      modalTitle={t(translations['global'], 'Patient Safety Certificate')}
      modalType="default"
      modalSize="md"
      modalButtonList={[
        ...(!viewStamp?.createDate
          ? [
              {
                buttonId: `button--modal-sp-seal-cancel`,
                buttonLeftIconName: 'SolidTimes',
                buttonSize: 'sm',
                buttonText: t(translations['global'], 'OK, I agree.'),
                isCloseButton: false,
                buttonType: 'secondary-outline' as IButtonType,
                customClasses: 'seal__buttons',
                buttonOnClickFunc: () => {
                  if (stamp) {
                    fetchViewStamp({
                      hospitalId: hospitalInfo?.hospitalId || '',
                      categoryId:
                        process.env
                          .NEXT_PUBLIC_PATIENTY_SAFETY_STAMP_CATEGORY_ID || '',
                      year: stamp.year,
                    });
                    hideModal(`modal--sp-seal-id`);
                  }
                },
              } as IEpModalButtonList,
            ]
          : []),
        {
          buttonId: `button--modal-sp-seal-cancel`,
          buttonLeftIconName: 'SolidBookReader',
          buttonSize: 'sm',
          buttonText: t(translations['global'], 'Learn More'),
          isCloseButton: false,
          buttonType: 'secondary-outline' as IButtonType,
          buttonOnClickFunc: () => {
            window.open(
              'https://www.epimedsolutions.com/certificacoes/',
              '_blank',
            );
          },
        },
      ]}
      customClasses="seal"
    >
      <div>
        <div
          className="ep-modal__content-body-title"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            // width: '100%',
            marginBottom: '10px',
          }}
        >
          <img
            src={process.env.NEXT_PUBLIC_BASE_API_URL_CDN + stamp?.img}
            alt={t(translations['global'], 'Patient Safety Certificate')}
            style={{
              maxHeight: '200px',
              maxWidth: '100%',
              objectFit: 'contain',
            }}
          />
        </div>

        <h3 className="seal__title">
          {Number(stamp?.year) >= new Date().getFullYear() - 1 && (
            <>{t(translations['global'], 'Congratulations!')} </>
          )}
          {contactInfo && contactInfo.hospitalName}
        </h3>

        <p className="ep-modal__content-body-long-desc seal__text">
          {isMexico
            ? t(
                translations['global'],
                'It is with great satisfaction that we inform you that your institution has won the Patient Safety Certificate, issued by Epimed Solutions.',
              )
            : t(
                translations['global'],
                'It is with great satisfaction that we inform you that your institution has won the Patient Safety Certificate, issued by Epimed Solutions in partnership with IBSP.',
              )}
        </p>

        <p className="ep-modal__content-body-long-desc seal__text">
          {isMexico
            ? Parse(
                t(
                  translations['global'],
                  'This institution won the Patient Safety Certificate, issued by Epimed Solutions. This certificate is awarded to institutions that meet the criteria for promoting good practices for Patient Safety related to the management of incidents and adverse events.',
                ),
              )
            : Parse(
                t(
                  translations['global'],
                  'This institution won the Patient Safety Certificate, issued by Epimed Solutions in partnership with IBSP. This certificate is awarded to institutions that meet the criteria for promoting good practices for Patient Safety related to the management of incidents and adverse events.',
                ),
              )}
        </p>
      </div>
    </EpModal>
  );
}
